import React, { useEffect, useState } from 'react';
import { Typography, Box } from '@mui/material';
import { useDispatch } from 'react-redux';

import { useTitle } from '../../hooks/titleProvider';
import { useAuth } from '../../contexts/authContext';
import { getOverviewGamesByUserId } from '../../features/game/gameSlice';
import { getVenues } from '../../features/venue/venueSlice';

import CurrentGames from './currentGames';
import OverviewActivityInsights from './activityInsights';

const Overview = () => {
  const dispatch = useDispatch();
  const { authenticated, currentUserProfile } = useAuth();
  const [games, setGames] = useState([]);
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);

  const { setTitle } = useTitle();
  setTitle('Home');

  useEffect(() => {
    if (!authenticated || !currentUserProfile?.id) {
      setGames([]);
      setVenues([]);
      setLoading(false);
      return;
    }

    let isMounted = true;

    const loadOverviewData = async () => {
      try {
        setLoading(true);
        const [overviewGames, allVenues] = await Promise.all([
          dispatch(getOverviewGamesByUserId()).unwrap(),
          dispatch(getVenues()).unwrap().catch(() => [])
        ]);

        if (!isMounted) {
          return;
        }

        setGames(Array.isArray(overviewGames) ? overviewGames : []);
        setVenues(Array.isArray(allVenues) ? allVenues : []);
      } catch (error) {
        if (!isMounted) {
          return;
        }

        setGames([]);
        setVenues([]);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadOverviewData();

    return () => {
      isMounted = false;
    };
  }, [authenticated, currentUserProfile?.id, dispatch]);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column'
      }}>
      <Box
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-evenly'}
        p={1}
        gap={2}
        flexWrap={'wrap'}>
        {/* <Box>
          <Typography variant="h5" component="h1" mb={1}>
            Private Games
          </Typography>

          {loading ? (
            <CircularProgress />
          ) : (
            <Box display={'flex'} flexDirection={isMobile ? 'column' : 'row'} gap={2}>
              {games.length === 0 && <Typography variant="caption">No games found</Typography>}
              {games.map((game, index) => (
                <Fragment key={game.id}>
                  <GameByStatusCards game={game} />
                </Fragment>
              ))}
            </Box>
          )}
        </Box> */}
        {/* <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h5" component="h1" mb={1}>
            Scoring Games
          </Typography>
          <UserScoring />
        </Box> */}
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h5" component="h1" mb={1}>
            Current Ongoing Games
          </Typography>
          <Typography variant="caption">Games updated in the last 30 minutes.</Typography>
          <CurrentGames />
        </Box>
      </Box>

      <Box px={1}>
        <OverviewActivityInsights games={games} venues={venues} loading={loading} />
      </Box>

      {/* <Box sx={{ position: 'relative' }}>
        <Box display="flex" gap={1} sx={{ position: 'fixed', bottom: 64, right: 16 }}>
          <AddPrivateGameDialog fab />
        </Box>
      </Box> */}
    </Box>
  );
};

export default Overview;
